import { Component, ChangeDetectionStrategy, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '@blockframes/auth/service';
import { Intercom } from '@supy-io/ngx-intercom';
import { supportEmails } from '@env';
import { displayName } from '@blockframes/model';

interface ConfirmationData {
  title: string,
  question: string,
  advice?: string,
  intercom?: string,
  email?: string,
  additionalData?: string[],
  confirm: string,
  cancel: string,
  onConfirm?: () => void,
  onClose?: (closedFrom: 'button') => void,
}

@Component({
  selector: 'blockframes-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmComponent {
  public supportEmail = supportEmails.waterfall;
  private emailSubject = $localize`Contacting the Blockframes Team`;
  private displayName = displayName(this.authService.profile);
  private emailBody = $localize`Hello Blockframes Team, I’d like to get in touch with you. Could you help me? Looking forward to your reply! Best, ${this.displayName}`;
  public emailParams = `?subject=${encodeURIComponent(this.emailSubject)}&body=${encodeURIComponent(this.emailBody)}`;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: ConfirmationData,
    public dialogRef: MatDialogRef<ConfirmComponent>,
    @Optional() private intercom: Intercom,
    private authService: AuthService,
  ) { }

  public confirm() {
    if (this.data.onConfirm) this.data.onConfirm();
    this.dialogRef.close(true);
  }

  public close(): void {
    if (this.data.onClose) this.data.onClose('button');
    this.dialogRef.close(false);
  }

  public openIntercom() {
    return this.intercom.show();
  }
}
